export default "__VITE_ASSET__BQON9gnH__"